import { ProcessesStatsSubtitle, StyledProcessesStatsItem } from './styles'

interface ProcessesStatsItemProps {
  title: string
  value: number | string | undefined
}

function ProcessesStatsItem(props: ProcessesStatsItemProps) {
  return (
    <StyledProcessesStatsItem>
      <ProcessesStatsSubtitle>{props.title}:</ProcessesStatsSubtitle>{' '}
      {props.value}
    </StyledProcessesStatsItem>
  )
}

export default ProcessesStatsItem
